var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"infoAliare"},[_c('i',{staticClass:"infoIcon"}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$props.textInfo)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }